'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '../../../shared/cn';
import { Link } from '../Link';
const styles = {
  destructive: ['text-contentRed!', 'data-focus:bg-backgroundRed data-hover:bg-backgroundRed', 'data-focus:text-contentRed data-hover:text-contentRed', '*:data-[slot=icon]:text-contentRed data-focus:*:data-[slot=icon]:text-contentRed data-hover:*:data-[slot=icon]:text-contentRed', '*:data-[slot=label]:text-contentRed group-data-focus:*:data-[slot=label]:text-contentRed group-data-hover:*:data-[slot=label]:text-contentRed']
} as const;
type DropdownItemProps = {
  className?: string;
  destructive?: boolean;
};
export function DropdownItem(t0) {
  const $ = _c(10);
  let className;
  let destructive;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      destructive,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = destructive;
    $[3] = props;
  } else {
    className = $[1];
    destructive = $[2];
    props = $[3];
  }
  const t1 = destructive && styles.destructive;
  let t2;
  if ($[4] !== className || $[5] !== t1) {
    t2 = cn("group rounded-lg px-3 py-1.5 focus:outline-hidden sm:px-4 sm:py-2", "data-disabled:cursor-not-allowed", "text-left  font-normal text-sm text-zinc-950  dark:text-white forced-colors:text-[CanvasText]", "data-focus:bg-backgroundHover data-focus:text-white", "data-disabled:opacity-50", "forced-color-adjust-none forced-colors:data-focus:bg-[Highlight] forced-colors:data-focus:text-[HighlightText] forced-colors:data-focus:*:data-[slot=icon]:text-[HighlightText]", "col-span-full grid grid-cols-[auto_1fr] items-center", "*:data-[slot=icon]:col-start-1 *:data-[slot=icon]:row-start-1 *:data-[slot=icon]:mr-2.5 *:data-[slot=icon]:-ml-0.5 *:data-[slot=icon]:size-5 sm:*:data-[slot=icon]:mr-3 sm:*:data-[slot=icon]:size-4", "*:data-[slot=icon]:text-contentSecondary data-focus:*:data-[slot=icon]:text-current", "*:data-[slot=avatar]:mr-2.5 *:data-[slot=avatar]:-ml-1 *:data-[slot=avatar]:size-6 sm:*:data-[slot=avatar]:mr-2 sm:*:data-[slot=avatar]:size-5", "data-hover:bg-backgroundHover", t1, className);
    $[4] = className;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const classes = t2;
  let t3;
  if ($[7] !== classes || $[8] !== props) {
    t3 = "href" in props ? <Headless.MenuItem as={Link} {...props} className={classes} /> : <Headless.MenuItem as="button" type="button" {...props} className={classes} />;
    $[7] = classes;
    $[8] = props;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}